import BackDrop from "@components/common/BackDrop";
import MediaAssets from "@components/utils/MediaAssets";
import Image from "next/legacy/image";
import { Dispatch, SetStateAction } from "react";

interface ICalendarToastToolTipProps {
  setSelectedDatesError: Dispatch<SetStateAction<boolean>>;
}

const CalendarToastToolTip = ({
  setSelectedDatesError,
}: ICalendarToastToolTipProps): JSX.Element => {
  const closeToastHandler = (): void => {
    setSelectedDatesError(false);
  };

  return (
    <div className="flex">
      <BackDrop closeModalHandler={closeToastHandler} />
      <div className="absolute bottom-[100px] flex h-[108px] w-[90%] place-items-center rounded-3xl bg-blue-10 p-5 px-[4rem] shadow-3xl">
        <div className="flex h-fit align-middle  ">
          <span>
            <Image
              src={MediaAssets.getAsset("warning")}
              width="30"
              height="30"
              layout="fixed"
              alt="warning"
            />
          </span>
          You need to select dates to proceed
        </div>
      </div>
      <div className="absolute left-[45%] bottom-[65px] justify-center border-[18px] border-transparent border-t-blue-10 shadow-3xl" />
    </div>
  );
};
export default CalendarToastToolTip;
